"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _formContext = require("./form-context");

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultClasses = {
  field: {
    error: 'invalid-feedback',
    invalid: 'is-invalid'
  },
  fieldGroup: {
    active: 'active',
    errors: 'is-invalid',
    touched: 'is-touched',
    completed: 'is-completed'
  }
};

var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "validateValue", function (validators, value) {
      var errors = [];
      validators.forEach(function (v) {
        var result = v(value);

        if (typeof result === 'string') {
          errors.push(result);
        }
      });
      return errors;
    });

    _defineProperty(_assertThisInitialized(_this), "validateForm", function (result, obj) {
      var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      Object.keys(obj).forEach(function (i) {
        var currentPath = [].concat(_toConsumableArray(path), [i]);
        var validator = obj[i];

        if (Array.isArray(validator)) {
          var _value = _this.api.getValue(currentPath.join('.'));

          var error = _this.validateValue(validator, _value);

          if (error && error.length > 0) {
            // eslint-disable-next-line no-param-reassign
            result.count += 1;

            _lodash["default"].set(result.errors, currentPath, error);
          }
        } else if (_typeof(validator) === 'object' && validator !== null) {
          _this.validateForm(result, validator, currentPath);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (event) {
      if (event) {
        event.preventDefault();
      }

      _this.api.submit();
    });

    _defineProperty(_assertThisInitialized(_this), "api", {
      setTouched: function setTouched(name, callback) {
        var _this$props = _this.props,
            validation = _this$props.validation,
            onTouch = _this$props.onTouch;

        var group = _this.api.getGroupByField(name);

        var combinedCallback = function combinedCallback() {
          if (onTouch) {
            onTouch(_this.api);
          }

          if (callback) {
            callback();
          }

          if (group) {
            _this.api.setGroupTouched(group.name);
          }
        };

        if (!validation) {
          combinedCallback();
          return;
        }

        var validators = _lodash["default"].get(validation(_this.api), name);

        if (validators && Array.isArray(validators) && validators.length > 0) {
          _this.setState(function (_ref) {
            var errors = _ref.errors,
                values = _ref.values;

            var value = _lodash["default"].get(values, name);

            _lodash["default"].set(errors, name, _this.validateValue(validators, value));

            return {
              errors: errors,
              values: values
            };
          }, combinedCallback);
        } else {
          combinedCallback();
        }
      },
      setValue: function setValue(name, value, callback) {
        var onChange = _this.props.onChange;

        _this.setState(function (_ref2) {
          var errors = _ref2.errors,
              values = _ref2.values;

          _lodash["default"].set(values, name, value);

          _lodash["default"].set(errors, name, []);

          return {
            values: values,
            errors: errors
          };
        }, function () {
          if (onChange) {
            onChange(_this.api, name);
          }

          if (callback) {
            callback();
          }
        });
      },
      getValue: function getValue(name) {
        var values = _this.state.values;
        return _lodash["default"].get(values, name);
      },
      removeValue: function removeValue(name) {
        var values = _this.state.values;
        return _lodash["default"].omit(values, name);
      },
      getValidator: function getValidator(name) {
        var validation = _this.props.validation;

        if (validation) {
          return _lodash["default"].get(validation(_this.api), name);
        }
      },
      validate: function validate(name) {
        var validator = _this.api.getValidator(name);

        var value = _this.api.getValue(name);

        if (validator) {
          return _this.validateValue(validator, value);
        }
      },
      getErrors: function getErrors(name) {
        var errors = _this.state.errors;
        return _lodash["default"].get(errors, name);
      },
      setErrors: function setErrors(name, value, callback) {
        _this.setState(function (_ref3) {
          var errors = _ref3.errors;

          _lodash["default"].set(errors, name, value);

          return {
            errors: errors
          };
        }, callback);
      },
      getClasses: function getClasses(name) {
        var _this$props2 = _this.props,
            classes = _this$props2.classes,
            errorClass = _this$props2.errorClass,
            invalidClass = _this$props2.invalidClass;

        var mergedClasses = _objectSpread({}, defaultClasses, {}, classes || {}); // TODO delete it in v.3


        if (errorClass) {
          mergedClasses.field.error = errorClass;
        } // TODO delete it in v.3


        if (invalidClass) {
          mergedClasses.field.invalid = invalidClass;
        }

        return mergedClasses[name];
      },
      getAllValues: function getAllValues() {
        var values = _this.state.values;
        return values;
      },
      getAllErrors: function getAllErrors() {
        var errors = _this.state.errors;
        return errors;
      },
      setAllErrors: function setAllErrors(errors, callback) {
        _this.setState({
          errors: errors
        }, callback);
      },
      setAllValues: function setAllValues(values, callback) {
        _this.setState({
          values: values
        }, callback);
      },
      getAllDisabled: function getAllDisabled() {
        var disabled = _this.state.disabled;
        return disabled;
      },
      setDisabled: function setDisabled(name) {
        _this.setState(function (_ref4) {
          var disabled = _ref4.disabled;

          if (!disabled.includes(name)) {
            return {
              disabled: [].concat(_toConsumableArray(disabled), [name])
            };
          }

          return {
            disabled: disabled
          };
        });
      },
      removeDisabled: function removeDisabled(name) {
        _this.setState(function (_ref5) {
          var disabled = _ref5.disabled;

          if (disabled.includes(name)) {
            return {
              disabled: disabled.filter(function (i) {
                return i !== name;
              })
            };
          }

          return {
            disabled: disabled
          };
        });
      },
      isDisabled: function isDisabled(name) {
        var disabled = _this.state.disabled;
        return disabled.includes(name);
      },
      getGroups: function getGroups() {
        var groups = _this.state.groups;
        return groups;
      },
      getGroup: function getGroup(name) {
        var groups = _this.state.groups;
        return groups.find(function (i) {
          return i.name === name;
        });
      },
      getGroupByField: function getGroupByField(name) {
        var groups = _this.state.groups;

        for (var _i = 0, _Object$entries = Object.entries(groups); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              group = _Object$entries$_i[1];

          if (group.fields.includes(name)) {
            return group;
          }
        }
      },
      upsertGroup: function upsertGroup(name) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var addField = arguments.length > 2 ? arguments[2] : undefined;
        var removeField = arguments.length > 3 ? arguments[3] : undefined;

        _this.setState(function (_ref6) {
          var groups = _ref6.groups;
          var selectedGroup = groups.find(function (g) {
            return g.name === name;
          });
          var selectedGroupIndex = groups.findIndex(function (g) {
            return g.name === name;
          });
          var group = selectedGroup || {
            name: name,
            isActive: false,
            hasErrors: false,
            isTouched: false,
            isCompleted: false,
            fields: []
          };
          var allGroups = groups;

          var updatedGroup = _objectSpread({}, group, {}, params);

          if (addField && !updatedGroup.fields.find(function (i) {
            return i === addField;
          })) {
            updatedGroup = _objectSpread({}, updatedGroup, {
              fields: [].concat(_toConsumableArray(updatedGroup.fields), [addField])
            });
          }

          if (removeField) {
            updatedGroup = _objectSpread({}, updatedGroup, {
              fields: updatedGroup.fields.filter(function (i) {
                return i !== removeField;
              })
            });
          }

          if (!group.isActive && updatedGroup.isActive) {
            allGroups = allGroups.map(function (i) {
              return _objectSpread({}, i, {
                isActive: false
              });
            });
          }

          if (updatedGroup.isTouched || updatedGroup.isActive) {
            var hasErrors = false;

            for (var i in updatedGroup.fields) {
              var fieldErrors = _this.api.validate(updatedGroup.fields[i]);

              if (fieldErrors && fieldErrors.length > 0) {
                hasErrors = true;
                break;
              }
            }

            updatedGroup = _objectSpread({}, updatedGroup, {
              hasErrors: hasErrors,
              isCompleted: !hasErrors
            });
          }

          if (selectedGroupIndex > -1) {
            allGroups[selectedGroupIndex] = updatedGroup;
          } else {
            allGroups.push(updatedGroup);
          }

          return {
            groups: allGroups
          };
        });
      },
      removeGroup: function removeGroup(name) {
        _this.setState(function (_ref7) {
          var groups = _ref7.groups;
          return {
            groups: groups.filter(function (i) {
              return i.name !== name;
            })
          };
        });
      },
      setGroupTouched: function setGroupTouched(name) {
        _this.api.upsertGroup(name, {
          isTouched: true
        });
      },
      setGroupActive: function setGroupActive(name) {
        _this.api.upsertGroup(name, {
          isActive: true
        });
      },
      hasGroupErrors: function hasGroupErrors(name) {
        var group = _this.api.getGroup(name);

        return group ? group.hasErrors : false;
      },
      addFieldToGroup: function addFieldToGroup(groupName, fieldName) {
        _this.api.upsertGroup(groupName, {}, fieldName);
      },
      removeFieldFromGroup: function removeFieldFromGroup(groupName, fieldName) {
        _this.api.upsertGroup(groupName, {}, undefined, fieldName);
      },
      getValuesDiff: function getValuesDiff(maxLevel) {
        var defaultValues = _this.props.defaultValues;
        var values = _this.state.values;
        return (0, _helpers.getValuesDiff)(defaultValues, values, maxLevel);
      },
      hasChanges: function hasChanges() {
        return !!Object.keys(_this.api.getValuesDiff()).length;
      },
      submit: function submit() {
        var _this$props3 = _this.props,
            validation = _this$props3.validation,
            onError = _this$props3.onError,
            onSubmit = _this$props3.onSubmit;
        var values = _this.state.values;
        var result = {
          count: 0,
          errors: {}
        };

        if (validation) {
          _this.validateForm(result, validation(_this.api));
        }

        _this.setState({
          errors: result.errors
        }, function () {
          if (result.count && onError) {
            onError(result.errors, _this.api);
          } else if (!result.count) {
            onSubmit(_lodash["default"].cloneDeep(values), _this.api);
          }
        });
      }
    });

    var _defaultValues = props.defaultValues,
        _invalidClass = props.invalidClass,
        _errorClass = props.errorClass;

    if (_invalidClass) {
      console.warn('`invalidClass` is deprecated, use `classes` instead');
    }

    if (_errorClass) {
      console.warn('`errorClass` is deprecated, use `classes` instead');
    }

    _this.state = {
      values: _lodash["default"].cloneDeep(_defaultValues),
      errors: {},
      disabled: [],
      groups: []
    };
    return _this;
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          defaultValues = _this$props4.defaultValues,
          onSubmit = _this$props4.onSubmit,
          onError = _this$props4.onError,
          onChange = _this$props4.onChange,
          onTouch = _this$props4.onTouch,
          validation = _this$props4.validation,
          classes = _this$props4.classes,
          invalidClass = _this$props4.invalidClass,
          errorClass = _this$props4.errorClass,
          element = _this$props4.element,
          props = _objectWithoutProperties(_this$props4, ["children", "defaultValues", "onSubmit", "onError", "onChange", "onTouch", "validation", "classes", "invalidClass", "errorClass", "element"]);

      var childrenComponent = typeof children === 'function' ? children(this.api) : children;
      return _react["default"].createElement(_formContext.ContextApi.Provider, {
        value: this.api
      }, _react["default"].createElement(_formContext.ContextForm.Provider, {
        value: this.state
      }, element === 'div' ? _react["default"].createElement("div", props, childrenComponent) : _react["default"].createElement("form", _extends({}, props, {
        onSubmit: this.onSubmit
      }), childrenComponent)));
    }
  }]);

  return Form;
}(_react["default"].Component);

exports.Form = Form;

_defineProperty(Form, "defaultProps", {
  defaultValues: {},
  onError: undefined,
  onChange: undefined,
  validation: undefined,
  classes: defaultClasses,
  invalidClass: undefined,
  errorClass: undefined,
  element: 'form'
});